import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { KXUserData } from "../Models/KXUserData";
import { ApiContextData, useApi } from "../Providers/APIProvider";
import { ApplyEligibilityCheckResponse } from "../Data/Responses/ApplyEligibilityCheckResponse";
import { Summary } from "./Summary";
import { KXYear } from "../Models/KXYear";
import { FeesRef } from "../Models/References/FeesRef";
import { LevelOfStudyRef } from "../Models/References/LevelOfStudyRef";
import { CampusRef } from "../Models/References/CampusRef";
import { GetKxAccommodationOffersForApplicantResponse } from "../Data/Responses/GetKxAccommodationOffersForApplicantResponse";
import Introduction from "../Components/Intros/Introduction";
import { BrowserRouter, Route, Routes } from "react-router";
import { ConstantImport } from "../Constants/ConstantImport";
import { SummerBookingRef } from "../Models/References/SummerBookingRef";
import { LoadingBlock } from "../Components/UI/LoadingBlock";
import { SiteResponse } from "src/Data/Responses/SiteResponse";
import { SiteWindowResponse } from "src/Data/Responses/SiteWindowResponse";
import { KillswitchEngage } from "../Components/UI/KillswitchEngage";
import { NoticeBlocks } from "../Components/UI/NoticeBlocks";
import { Commentator } from "../Components/UI/Commentator";
import { AdminAccess } from "../Components/AdminAccess";

export interface PortalProps {
    Ident: string;
    ThisAcademicYear: KXYear;
    NextAcademicYear: KXYear;
    Debug: boolean;

    SiteAdmins: Array<String> | undefined;
    SetSiteAdmins: Dispatch<SetStateAction<String[] | undefined>>;
}

export function Portal(props: PortalProps) {
    const API = useApi();

    const [SiteProperties, SetSiteProperties] = useState<SiteResponse | undefined>(undefined);
    const [SiteTimeWindows, SetSiteTimeWindows] = useState<Array<SiteWindowResponse> | undefined>(undefined);

    const [api, setApi] = useState<ApiContextData | undefined>(undefined);

    useEffect(() => {
        if (API !== undefined) {
            if (SiteTimeWindows === undefined) {
                API.Accommodation.GetActiveSiteWindowsBySiteName("KXStudentAccommodationPortal").then(data => {
                    if (data !== undefined) {
                        // console.log(data);
                        SetSiteTimeWindows(data);
                    } else {
                        // console.log("boom");
                    }
                });
            }
            if (SiteProperties === undefined) {
                API.Accommodation.GetSiteByName("KXStudentAccommodationPortal").then(data => {
                    if (data !== undefined) {
                        // console.log(data);
                        SetSiteProperties(data);
                    } else {
                        // console.log("boom");
                    }
                });
            }
        }
    }, [API]);

    useEffect(() => {
        if (API !== undefined && props.SiteAdmins === undefined) {
            API.Accommodation.GetAdminsBySiteName("KXStudentAccommodationPortal").then(data => {
                if (data !== undefined) {
                    props.SetSiteAdmins(data);
                } else {
                    props.SetSiteAdmins([]);
                }
            });
        }
    }, [API, props.SiteAdmins]);

    useEffect(() => {
        if (API !== undefined && SiteProperties !== undefined && SiteTimeWindows !== undefined) {
            if (SiteProperties.Killswitch !== true) {
                setApi(API);
            }
        }
    }, [API, SiteProperties, SiteTimeWindows])

    const [TestUser, setTestUser] = useState<KXUserData>();

    const [TestAppThisYearOffers, setTestAppThisYearOffers] = useState<GetKxAccommodationOffersForApplicantResponse>();
    const [TestAppNextYearOffers, setTestAppNextYearOffers] = useState<GetKxAccommodationOffersForApplicantResponse>();
    const [TestAppSummerOffers, setTestAppSummerOffers] = useState<GetKxAccommodationOffersForApplicantResponse>();

    const [KxThisStudentGuid, setKxThisStudentGuid] = useState<string>();
    const [TestAppThisYearEligibility, setTestAppThisYearEligibility] = useState<ApplyEligibilityCheckResponse>();
    const [ThisApplicationTypeID_CHECK, setThisApplicationTypeID_CHECK] = useState<number>(0);
    const [ThisApplicantTypeID_ROOT, setThisApplicantTypeID_ROOT] = useState<number>();
    const [ThisStatusDescription, setThisStatusDescription] = useState<string>();
    const [ThisStatusFlag, setThisStatusFlag] = useState<string>();
    const [ThisEventID, setThisEventID] = useState<string>();

    const [KxNextStudentGuid, setKxNextStudentGuid] = useState<string>();
    const [TestAppNextYearEligibility, setTestAppNextYearEligibility] = useState<ApplyEligibilityCheckResponse>();
    const [NextApplicationTypeID_CHECK, setNextApplicationTypeID_CHECK] = useState<number>(0);
    const [NextApplicantTypeID_ROOT, setNextApplicantTypeID_ROOT] = useState<number>();
    const [NextStatusDescription, setNextStatusDescription] = useState<string>();
    const [NextStatusFlag, setNextStatusFlag] = useState<string>();
    const [NextEventID, setNextEventID] = useState<string>();

    const [KxSummerStudentGuid, setKxSummerStudentGuid] = useState<string>();
    const [TestAppSummerEligibility, setTestAppSummerEligibility] = useState<{
        Error: string;
        Ready: boolean;
    }>();
    const [SummerApplicationTypeID, setSummerApplicationTypeID] = useState<number>(0);
    const [SummerStatusDescription, setSummerStatusDescription] = useState<string>();
    const [SummerStatusFlag, setSummerStatusFlag] = useState<string>();

    const [Eligible, setEligible] = useState<boolean>();

    const [KXError, setKXError] = useState<string>();

    const ThisApplicationTypeID = ThisApplicantTypeID_ROOT ?? ThisApplicationTypeID_CHECK;
    const NextApplicationTypeID = NextApplicantTypeID_ROOT ?? NextApplicationTypeID_CHECK;

    const ThisYear = {
        KxThisStudentGuid: KxThisStudentGuid,
        TestAppThisYearEligibility: TestAppThisYearEligibility,
        ThisApplicationTypeID_CHECK: ThisApplicationTypeID_CHECK,
        ThisApplicantTypeID_ROOT: ThisApplicantTypeID_ROOT,
        ThisStatusDescription: ThisStatusDescription,
        ThisStatusFlag: ThisStatusFlag,
        ThisEventID: ThisEventID
    };

    const NextYear = {
        KxNextStudentGuid: KxNextStudentGuid,
        TestAppNextYearEligibility: TestAppNextYearEligibility,
        NextApplicationTypeID_CHECK: NextApplicationTypeID_CHECK,
        NextApplicantTypeID_ROOT: NextApplicantTypeID_ROOT,
        NextStatusDescription: NextStatusDescription,
        NextStatusFlag: NextStatusFlag,
        NextEventID: NextEventID
    };

    const Summer = {
        KxSummerStudentGuid: KxSummerStudentGuid,
        TestAppSummerEligibility: TestAppSummerEligibility,
        SummerApplicationTypeID: SummerApplicationTypeID,
        SummerStatusDescription: SummerStatusDescription,
        SummerStatusFlag: SummerStatusFlag
    };

    const _debug = false;

    if (props.Debug || _debug) console.log("TestUser");
    if (props.Debug || _debug) console.log(TestUser);
    if (props.Debug || _debug) console.log("ThisYear");
    if (props.Debug || _debug) console.log(ThisYear);
    if (props.Debug || _debug) console.log("NextYear");
    if (props.Debug || _debug) console.log(NextYear);
    if (props.Debug || _debug) console.log("Summer");
    if (props.Debug || _debug) console.log(Summer);

    useEffect(() => {
        if (api !== undefined && props.Ident !== undefined && props.Ident !== "") {
            const _debug = false;
            if (props.Debug || _debug) { console.log("init hook SHOULD ONLY RUN ONCE"); }
            if (props.Debug || _debug) { console.log(props.Ident); }
            api.Accommodation.GetStudentTimetablePortalCoreData(props.Ident).then(response => {
                if (response === undefined) {
                    // 204
                    setTestUser(undefined);
                } else {
                    let ReadableData = { ...response };
                    let FeeIndex = Number.parseInt(ReadableData.FeeStatus);
                    ReadableData.FeeStatus = FeesRef[FeeIndex];
                    ReadableData.CampusID = CampusRef[ReadableData.CampusID];
                    ReadableData.LevelOfStudy = LevelOfStudyRef[ReadableData.LevelOfStudy];
                    setTestUser(ReadableData);
                    if (props.Debug || _debug) { console.log("init hook => setTestUser"); }
                }
            });
        }
    }, [api, props.Ident]);

    useEffect(() => {
        if (api !== undefined && TestUser !== undefined && TestUser.PRID !== undefined && TestUser.ASRKey !== undefined && props.ThisAcademicYear.KXID !== undefined && props.NextAcademicYear.KXID !== undefined) {
            api.Accommodation.GetAllAppTypes(TestUser.PRID, TestUser.ASRKey, props.ThisAcademicYear.KXID, props.NextAcademicYear.KXID).then(data => {
                // console.log("GetAllAppTypes...");
                // console.log(data);
                setEligible(data.Eligible);
                if (data.Eligible) {
                    if (data.CurrentPhaseEventID !== "") {
                        setThisApplicantTypeID_ROOT(data.CurrentApplicantType);
                        setThisEventID(data.CurrentPhaseEventID);
                    } else {
                        setThisApplicantTypeID_ROOT(undefined);
                        setThisEventID(undefined);
                    }
                    if (data.NextPhaseEventID !== "") {
                        setNextApplicantTypeID_ROOT(data.NextApplicantType);
                        setNextEventID(data.NextPhaseEventID);
                    } else {
                        setNextApplicantTypeID_ROOT(undefined);
                        setNextEventID(undefined);
                    }
                }
            })
        }
    }, [api, TestUser, props.ThisAcademicYear.KXID, props.NextAcademicYear.KXID]);

    useEffect(() => {
        const _debug = false;
        if (props.Debug || _debug) console.log('This --> ApplyEligibilityCheck effect...');
        if (props.Debug || _debug) console.log(TestUser);
        if (props.Debug || _debug) console.log(ThisApplicationTypeID);
        if (props.Debug || _debug) console.log(props.ThisAcademicYear);
        if (api !== undefined && TestUser !== undefined
            && TestUser.PRID !== undefined
            && ThisApplicationTypeID !== undefined
            && ThisApplicationTypeID !== null
            && ThisApplicationTypeID !== 0
            && props.ThisAcademicYear.KXID !== undefined
            && TestAppThisYearEligibility === undefined) {
            api.Accommodation.ApplyEligibilityCheck(TestUser.PRID, props.ThisAcademicYear.KXID, ThisApplicationTypeID)
                .then(data => {
                    if (props.Debug || _debug) console.log(data);
                    setTestAppThisYearEligibility(data);
                    setKxThisStudentGuid(data.KXStudentGuid);
                });
        }
    }, [api, TestUser, ThisApplicationTypeID, props.ThisAcademicYear.KXID]);

    useEffect(() => {
        const _debug = false;
        if (props.Debug || _debug) console.log('Next --> ApplyEligibilityCheck effect...');
        if (props.Debug || _debug) console.log(TestUser);
        if (props.Debug || _debug) console.log(NextApplicationTypeID);
        if (props.Debug || _debug) console.log(props.NextAcademicYear);
        if (api !== undefined && TestUser !== undefined
            && TestUser.PRID !== undefined
            && NextApplicationTypeID !== undefined
            && NextApplicationTypeID !== null
            && NextApplicationTypeID !== 0
            && props.NextAcademicYear.KXID !== undefined
            && TestAppNextYearEligibility === undefined) {
            api.Accommodation.ApplyEligibilityCheck(TestUser.PRID, props.NextAcademicYear.KXID, NextApplicationTypeID)
                .then(data => {
                    if (props.Debug || _debug) console.log(data);
                    setTestAppNextYearEligibility(data);
                    setKxNextStudentGuid(data.KXStudentGuid);
                });
        }
    }, [api, TestUser, NextApplicationTypeID, props.NextAcademicYear.KXID]);

    useEffect(() => {
        const _debug = false;
        if (props.Debug || _debug) console.log('Summer --> ApplyEligibilityCheck effect...');
        if (props.Debug || _debug) console.log(TestUser);
        if (props.Debug || _debug) console.log(SummerApplicationTypeID);
        if (props.Debug || _debug) console.log(props.ThisAcademicYear);
        if (props.Debug || _debug) console.log(TestAppSummerEligibility);
        if (api !== undefined && TestUser !== undefined
            && TestUser.PRID !== undefined
            && SummerApplicationTypeID !== undefined
            && SummerApplicationTypeID !== null
            && SummerApplicationTypeID !== 0
            && props.ThisAcademicYear.KXID !== undefined
            && (TestAppSummerEligibility === undefined || TestAppSummerEligibility.Ready === true)) {
            if (props.Debug || _debug) console.log('Summer --> ApplyEligibilityCheck runnable:');
            api.Accommodation.ApplyEligibilityCheck(TestUser.PRID, props.ThisAcademicYear.KXID, SummerApplicationTypeID)
                .then(data => {
                    if (props.Debug || _debug) console.log(data);
                    setTestAppSummerEligibility(data);
                    setKxSummerStudentGuid(data.KXStudentGuid);
                });
        }
    }, [api, TestUser, SummerApplicationTypeID, props.ThisAcademicYear.KXID]);

    useEffect(() => {
        if (api !== undefined && TestUser !== undefined && TestUser.PRID !== undefined && props.ThisAcademicYear.KXID !== undefined) {
            api.Accommodation.GetStudentGUIDApplicantTypeID(TestUser.PRID, props.ThisAcademicYear.KXID).then(data => {
                if (data.ApplicationTypeID !== null && data.KxStudentGuid !== null) {
                    if (data.ApplicationTypeID === 178 || data.ApplicationTypeID === 179) {
                        setSummerApplicationTypeID(data.ApplicationTypeID);
                        if (IsNullOrEmpty(KxThisStudentGuid)) {
                            setKxSummerStudentGuid(data.KxStudentGuid);
                        }
                    } else {
                        setThisApplicationTypeID_CHECK(data.ApplicationTypeID);
                        if (IsNullOrEmpty(KxThisStudentGuid)) {
                            setKxThisStudentGuid(data.KxStudentGuid);
                        }
                    }
                }
            });
        }
    }, [api, TestUser, props.ThisAcademicYear.KXID]);

    useEffect(() => {
        if (api !== undefined && TestUser !== undefined && TestUser.PRID !== undefined && props.NextAcademicYear.KXID !== undefined) {
            api.Accommodation.GetStudentGUIDApplicantTypeID(TestUser.PRID, props.NextAcademicYear.KXID).then(data => {
                if (data.ApplicationTypeID !== null && data.KxStudentGuid !== null) {
                    setNextApplicationTypeID_CHECK(data.ApplicationTypeID);
                    if (IsNullOrEmpty(KxNextStudentGuid)) {
                        setKxNextStudentGuid(data.KxStudentGuid);
                    }
                }
            });
        }
    }, [api, TestUser, props.NextAcademicYear.KXID]);

    // Whenever TestUser changes,
    // check TestUser and TestUser.PRID have values,
    // and if they do, run the CheckSummerBooking method off the PRID,
    // then store the return value as SummerApplicationTypeID
    // and if the return value is 178/179, store a SummerEligibility object { Ready: true }
    // otherwise { Ready: false, Error: "Relevant Error From Lookup" }.
    useEffect(() => {
        if (api !== undefined && TestUser !== undefined && TestUser.PRID !== undefined) {
            api.Accommodation.CheckSummerBooking(TestUser.PRID).then(data => {
                if (data !== undefined && data !== null) {
                    setSummerApplicationTypeID(data);
                    var elig = { Error: "", Ready: false };
                    if (data === 178 || data === 179) {
                        elig.Ready = true;
                    } else {
                        elig.Error = SummerBookingRef[data].Short;
                    }
                    setTestAppSummerEligibility(elig);
                }
            });
        }
    }, [api, TestUser]);

    useEffect(() => {
        if (api !== undefined && TestUser !== undefined && TestUser.PRID !== undefined && ThisApplicantTypeID_ROOT !== undefined && props.ThisAcademicYear.KXID !== undefined) {
            api.Accommodation.GetKxAccommodationOffersForApplicant(TestUser.PRID, props.ThisAcademicYear.KXID, ThisApplicationTypeID).then(data => {
                if (data.StatusFlag !== "") {
                    let TreatedData = { ...data };
                    if (TreatedData.HasOfferDependingOnAppTypeID) {
                        if (ThisApplicantTypeID_ROOT === 0) {
                            TreatedData.HasOfferDependingOnAppTypeID = false;
                        }
                    }
                    setTestAppThisYearOffers(TreatedData);
                } else {
                    setTestAppThisYearOffers(undefined);
                }
            });
        }
    }, [api, TestUser, ThisApplicantTypeID_ROOT, props.ThisAcademicYear.KXID]);

    useEffect(() => {
        if (api !== undefined && TestUser !== undefined && TestUser.PRID !== undefined && NextApplicantTypeID_ROOT !== undefined && props.NextAcademicYear.KXID !== undefined) {
            api.Accommodation.GetKxAccommodationOffersForApplicant(TestUser.PRID, props.NextAcademicYear.KXID, NextApplicationTypeID).then(data => {
                if (data.StatusFlag !== "") {
                    let TreatedData = { ...data };
                    if (TreatedData.HasOfferDependingOnAppTypeID) {
                        if (NextApplicantTypeID_ROOT === 0) {
                            TreatedData.HasOfferDependingOnAppTypeID = false;
                        }
                    }
                    setTestAppNextYearOffers(data);
                } else {
                    setTestAppNextYearOffers(undefined);
                }
            });
        }
    }, [api, TestUser, NextApplicantTypeID_ROOT, props.NextAcademicYear.KXID]);

    useEffect(() => {
        if (api !== undefined && TestUser !== undefined && TestUser.PRID !== undefined && SummerApplicationTypeID !== undefined && SummerApplicationTypeID !== 0 && props.ThisAcademicYear.KXID !== undefined) {
            api.Accommodation.GetKxAccommodationOffersForApplicant(TestUser.PRID, props.ThisAcademicYear.KXID, SummerApplicationTypeID).then(data => {
                if (data.StatusFlag !== "") {
                    let TreatedData = { ...data };
                    if (TreatedData.HasOfferDependingOnAppTypeID) {
                        if (NextApplicantTypeID_ROOT === 0) {
                            TreatedData.HasOfferDependingOnAppTypeID = false;
                        }
                    }
                    setTestAppSummerOffers(data);
                } else {
                    setTestAppSummerOffers(undefined);
                }
            });
        }
    }, [api, TestUser, SummerApplicationTypeID, props.ThisAcademicYear.KXID]);

    useEffect(() => {
        if (api !== undefined && TestUser !== undefined && TestUser.PRID !== undefined && ThisApplicationTypeID !== undefined && ThisApplicationTypeID !== 0 && props.ThisAcademicYear.KXID !== undefined) {
            api.Accommodation.GetKxAccommodationApplicationForApplicant(TestUser.PRID, props.ThisAcademicYear.KXID, ThisApplicationTypeID).then(data => {
                if (data === undefined) {
                    setThisStatusDescription(undefined);
                    setThisStatusFlag(undefined);
                } else {
                    setThisStatusDescription(data.StatusDescription);
                    setThisStatusFlag(data.StatusFlag);
                }
            });
        }
    }, [api, TestUser, ThisApplicationTypeID, props.ThisAcademicYear.KXID]);

    useEffect(() => {
        if (api !== undefined && TestUser !== undefined && TestUser.PRID !== undefined && NextApplicationTypeID !== undefined && NextApplicationTypeID !== 0 && props.NextAcademicYear.KXID !== undefined) {
            api.Accommodation.GetKxAccommodationApplicationForApplicant(TestUser.PRID, props.NextAcademicYear.KXID, NextApplicationTypeID).then(data => {
                if (data === undefined) {
                    setNextStatusDescription(undefined);
                    setNextStatusFlag(undefined);
                } else {
                    setNextStatusDescription(data.StatusDescription);
                    setNextStatusFlag(data.StatusFlag);
                }
            });
        }
    }, [api, TestUser, NextApplicationTypeID, props.NextAcademicYear.KXID]);

    useEffect(() => {
        if (api !== undefined && TestUser !== undefined && TestUser.PRID !== undefined && SummerApplicationTypeID !== undefined && props.ThisAcademicYear.KXID !== undefined) {
            api.Accommodation.GetKxAccommodationApplicationForApplicant(TestUser.PRID, props.ThisAcademicYear.KXID, SummerApplicationTypeID).then(data => {
                if (data === undefined) {
                    setSummerStatusDescription(undefined);
                    setSummerStatusFlag(undefined);
                } else {
                    setSummerStatusDescription(data.StatusDescription);
                    setSummerStatusFlag(data.StatusFlag);
                }
            });
        }
    }, [api, TestUser, SummerApplicationTypeID, props.ThisAcademicYear.KXID]);

    /*
    We don't actually _use_ these dates anywhere - the only intros that parse them are the Ballots, and they've been swapped out for Fees intros anyway!

    useEffect(() => {
        if (ThisEventID !== undefined) {
            api.Accommodation.GetClosingDateByEventID(ThisEventID).then(data => setThisClosingDate(data));
        }
    }, [ThisEventID]);

    useEffect(() => {
        if (NextEventID !== undefined) {
            api.Accommodation.GetClosingDateByEventID(NextEventID).then(data => setNextClosingDate(data));
        }
    }, [NextEventID]);
    */

    // This <input type="checkbox" checked={ShowThisIntro} onChange={(e) => { setShowThisIntro(e.currentTarget.checked) }}></input>
    // Next <input type="checkbox" checked={ShowNextIntro} onChange={(e) => { setShowNextIntro(e.currentTarget.checked) }}></input>

    return <>
        {
            SiteProperties?.Killswitch === true
                ?
                <KillswitchEngage SiteProperties={SiteProperties} SiteTimeWindows={SiteTimeWindows}></KillswitchEngage>
                :
                <>
                    {(SiteTimeWindows !== undefined && SiteTimeWindows.length > 0) && <NoticeBlocks SiteTimeWindows={SiteTimeWindows}></NoticeBlocks>}
                    <BrowserRouter basename={ConstantImport.BaseURL}>
                        <Routes>
                            <Route path="" element={
                                (props.ThisAcademicYear !== undefined && props.NextAcademicYear !== undefined && TestUser !== undefined) ?
                                    <Summary
                                        Eligible={Eligible! || (TestAppSummerEligibility?.Ready ?? false)}
                                        KXError={KXError!}
                                        Campus={TestUser.CampusID!}
                                        StudyLevel={TestUser.LevelOfStudy!}
                                        ThisAcadYear={props.ThisAcademicYear}
                                        NextAcadYear={props.NextAcademicYear}
                                        KXUserData={TestUser}
                                        ThisEventID={ThisEventID}
                                        NextEventID={NextEventID}

                                        KXAppThisYearEligibility={TestAppThisYearEligibility!}
                                        ThisApplicationTypeID={ThisApplicationTypeID!}
                                        ThisStatusFlag={ThisStatusFlag!}
                                        ThisStatusDescription={ThisStatusDescription!}
                                        KxThisStudentGuid={KxThisStudentGuid!}
                                        KXAppThisYearOffers={TestAppThisYearOffers!}

                                        KXAppNextYearEligibility={TestAppNextYearEligibility!}
                                        NextApplicationTypeID={NextApplicationTypeID!}
                                        NextStatusFlag={NextStatusFlag!}
                                        NextStatusDescription={NextStatusDescription!}
                                        KxNextStudentGuid={KxNextStudentGuid!}
                                        KXAppNextYearOffers={TestAppNextYearOffers!}

                                        KXAppSummerEligibility={TestAppSummerEligibility!}
                                        SummerApplicationTypeID={SummerApplicationTypeID!}
                                        SummerStatusFlag={SummerStatusFlag!}
                                        SummerStatusDescription={SummerStatusDescription!}
                                        KxSummerStudentGuid={KxSummerStudentGuid!}
                                        KXAppSummerOffers={TestAppSummerOffers!}

                                        SiteAdmins={props.SiteAdmins}
                                    />
                                    :
                                    <LoadingBlock></LoadingBlock>
                            } />
                            <Route path="CurrentYear" element={
                                <Introduction
                                    EventID={ThisEventID}
                                    Campus={TestUser?.CampusID ?? ""}
                                    AcadYearLabel={props.ThisAcademicYear.KXFormat}
                                    StudentGUID={KxThisStudentGuid}
                                    SiteAdmins={props.SiteAdmins}
                                ></Introduction>
                            } />
                            <Route path="NextYear" element={
                                <Introduction
                                    EventID={NextEventID}
                                    Campus={TestUser?.CampusID ?? ""}
                                    AcadYearLabel={props.NextAcademicYear.KXFormat}
                                    StudentGUID={KxNextStudentGuid}
                                    SiteAdmins={props.SiteAdmins}
                                ></Introduction>
                            } />
                            <Route path="Summer" element={
                                <Introduction
                                    EventID="SUMMER"
                                    Campus={TestUser?.CampusID ?? ""}
                                    AcadYearLabel={props.ThisAcademicYear.KXFormat}
                                    StudentGUID={KxSummerStudentGuid}
                                    SiteAdmins={props.SiteAdmins}
                                ></Introduction>
                            } />
                        </Routes>
                    </BrowserRouter>
                </>
        }
        <AdminAccess SiteAdmins={props.SiteAdmins} DeniedMessage={<Commentator Display={false} SiteProperties={SiteProperties} SiteTimeWindows={SiteTimeWindows} />}>
            <Commentator Display={true} SiteProperties={SiteProperties} SiteTimeWindows={SiteTimeWindows} />
        </AdminAccess>
    </>;
}

function IsNullOrEmpty(input: string | undefined) {
    return !(input === undefined && input === null && input !== "");
}
